import { SaveAlt, ArrowDropDown } from '@mui/icons-material';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { TaxService } from '../TaxService';
import stateList from '../../../../utils/stateList.json';

const ExportAll = (props) => {
  const { paginationModel } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  // Define custom headers and their corresponding data mapping
  const exportMapping = [
    {
          header: 'SL. NO.',
          value: (row, index) => `${index + 1}`
        },
        {
          header: 'Invoice Number',
          value: (row) => `${row.invoiceNumber}`
        },
        {
          header: 'Invoice Type',
          value: (row) => `CuDel Expert Wallet Invoice`
        },
        {
          header: 'Service',
          value: (row) => `Subscription Charge`
        },
        {
          header: 'Month/Year',
          value: (row) => `${row?.month
                            ? new Date(row.year, row.month - 1).toLocaleString('default', { month: 'short' })
                            : ''}, ${row.year}`
        },
        {
          header: 'State Code',
          value: (row) => `${stateList.find(s => s.name == row?.expert?.UserAddress?.state)?.code || ''}`
        },
        {
          header: 'Client Name',
          value: (row) => `${row.expert?.UserProfile?.firstName ||''} ${row.expert?.UserProfile?.middleName ||''} ${row.expert?.UserProfile?.lastName ||''}`
        },
        {
          header: 'Client GST Number',
          value: (row) => `${row.expert?.UserBusinessDetail?.gstNumber || ''}`
        },
        {
          header: 'Client PAN NUMBER',
          value: (row) => `${row.expert?.UserBusinessDetail?.panNumber || ''}`
        },
        {
          header: 'Client Adress',
          value: (row) => `${row?.expert?.UserAddress?.address || ''}`
        },
        {
          header: 'Base Amount',
          value: (row) => `${row.baseAmount}`
        },
        {
          header: 'Disc. Amount',
          value: (row) => `${row.discountAmount}`
        },
        {
          header: 'TAXABLE',
          value: (row) => `${row.taxableAmount || ''}`
        },
        {
          header: 'IGST',
          value: (row) => `${row.igst || ''}`
        },
        {
          header: 'CGST',
          value: (row) => `${row.cgst || ''}`
        },
        {
          header: 'SGST',
          value: (row) => `${row.sgst || ''}`
        },
        {
          header: 'Total GST',
          value: (row) => `${row.totalTax || ''}`
        },
        {
          header: 'Total Amount',
          value: (row) => `${row.billingAmount || ''}`
        },
        {
          header: 'Rate',
          value: (row) => `18%`
        },
        {
          header: 'Opening Balance',
          value: (row) => `${row.openingBalance || ''}`
        },
        {
          header: 'Total Debited Amount',
          value: (row) => `${row.totalDebitAmount || ''}`
        },{
          header: 'Total Credited Amount',
          value: (row) => `${row.totalCreditAmount || ''}`
        },
        {
          header: 'Closing Balance',
          value: (row) => `${row.closingBalance || ''}`
        },
        {
          header: 'REMARKS',
          value: (row) => `${row.remark || ''}`
        },
  ];

  const fetchAndDownloadCsv = async (mapping, fileName, isOfficial = false) => {
    const listResponse = await TaxService.fetchWalletSummaryExportList({
      filters: {
        searchKey: paginationModel.filters.searchKey,
        sortBy: paginationModel.filters.sortBy,
        sortType: paginationModel.filters.sortType,
        filterOptions: paginationModel.filters.filterOptions || []
      }
    });
    const exportData = listResponse.data.list.map((row, index) =>
      mapping.reduce((acc, field) => {
        acc[field.header] = field.value(row, index);
        return acc;
      }, {})
    );
    const headers = mapping.map(field => `"${field.header}"`).join(',');
    const rows = exportData.map(row =>
      mapping.map(field => {
        const val = String(row[field.header] ?? '').replace(/"/g, '""');
        return `"${isOfficial && val.trim() === '' ? '-' : val}"`;
      }).join(',')
    );
    rows.unshift(headers);
    const csvString = '\uFEFF' + rows.join('\n');
    const blob = new Blob(['\uFEFF', csvString], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return url;
  };

  const handleExportAllRows = async () => {
    try {
      Swal.fire({ title: 'Exporting Data', text: 'Please wait while we prepare your download...', icon: 'info', allowOutsideClick: false, didOpen: () => { Swal.showLoading(); } });
      const url = await fetchAndDownloadCsv(exportMapping, 'Expert-wallet-monthly-report');
      Swal.fire({
        title: 'Export Successful',
        html: `<p>If download doesn't start automatically, click: <a href="${url}" download="Expert-Wallet-Summary-report.csv" style="color:blue;text-decoration:underline;">Download CSV</a></p>`,
        icon: 'success', showConfirmButton: true, confirmButtonText: 'Close'
      });
    } catch (error) {
      console.error('Export failed', error);
      Swal.fire({ title: 'Export Failed', text: 'There was an issue exporting the data. Please try again.', icon: 'error' });
    }
  };

  const officialExportMapping = [
    { header: 'SL. NO.',           value: (row, i) => `${i + 1}` },
    { header: 'Branch',            value: () => 'NOIDA' },
    { header: 'Invoice Type',      value: () => 'CuDel Expert Wallet Invoice' },
    { header: 'Invoice No',        value: (row) => `${row.invoiceNumber}` },
    { header: 'Date',              value: (row) => row?.month ? `="${row.year}-${String(row.month).padStart(2,'0')}-01"` : '' },
    { header: 'State Code',        value: (row) => `${stateList.find(s => s.name === row?.expert?.UserAddress?.state)?.code || ''}` },
    { header: 'Client Name',       value: (row) => `${row.expert?.UserProfile?.firstName || ''} ${row.expert?.UserProfile?.middleName || ''} ${row.expert?.UserProfile?.lastName || ''}`.trim() },
    { header: 'Client GST Number', value: (row) => row.expert?.UserBusinessDetail?.gstNumber ? `="${row.expert.UserBusinessDetail.gstNumber}"` : '' },
    { header: 'Client PAN NUMBER', value: (row) => row.expert?.UserBusinessDetail?.panNumber ? `="${row.expert.UserBusinessDetail.panNumber}"` : '' },
    { header: 'Client Adress',     value: (row) => `${row?.expert?.UserAddress?.address || ''}` },
    { header: 'Narration',         value: () => 'Subscription Charge' },
    { header: 'TAXABLE',           value: (row) => `${row.taxableAmount || ''}` },
    { header: 'IGST',              value: (row) => `${row.igst || ''}` },
    { header: 'CGST',              value: (row) => `${row.cgst || ''}` },
    { header: 'SGST',              value: (row) => `${row.sgst || ''}` },
    { header: 'Total GST',         value: (row) => `${row.totalTax || ''}` },
    { header: 'Total Amount',      value: (row) => `${row.billingAmount || ''}` },
    { header: 'Rate',              value: () => '18%' },
    { header: 'ACK',               value: () => '' },
    { header: 'IRN',               value: () => '' },
    { header: 'SAC Code',          value: () => '' },
    { header: 'Our Entity Name',   value: () => 'CuDel Delight Solutions Pvt. Ltd' },
    { header: 'Entity GST number', value: () => '09AAHCC6070E1ZP' },
    { header: 'REMARKS',           value: () => 'CuDel Expert Wallet Invoice' },
  ];

  const handleOfficialExport = async () => {
    try {
      Swal.fire({ title: 'Exporting Data', text: 'Please wait while we prepare your download...', icon: 'info', allowOutsideClick: false, didOpen: () => { Swal.showLoading(); } });
      const url = await fetchAndDownloadCsv(officialExportMapping, 'GST-Output-Expert-Wallet-Report', true);
      Swal.fire({
        title: 'Official Export Successful',
        html: `<p>If download doesn't start automatically, click: <a href="${url}" download="GST-Output-Expert-Wallet-Report.csv" style="color:blue;text-decoration:underline;">Download CSV</a></p>`,
        icon: 'success', showConfirmButton: true, confirmButtonText: 'Close'
      });
    } catch (error) {
      console.error('Official export failed', error);
      Swal.fire({ title: 'Export Failed', text: 'There was an issue exporting the data. Please try again.', icon: 'error' });
    }
  };

  return (
    <Box>
      <Button
        onClick={handleMenuOpen}
        startIcon={<SaveAlt />}
        endIcon={<ArrowDropDown />}
        sx={{ textTransform: 'none' }}
      >
        Export
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
        <MenuItem
          onClick={() => { handleExportAllRows(); handleMenuClose(); }}
          sx={{ fontSize: '.8rem' }}
        >
          Internal Export
        </MenuItem>
        <MenuItem
          onClick={() => { handleOfficialExport(); handleMenuClose(); }}
          sx={{ fontSize: '.8rem' }}
        >
          Official Export
        </MenuItem>
      </Menu>
    </Box>
  );
}

export default ExportAll;